<template>
    <div>
        <form @submit.prevent="saveFieldChecked" class="form-horizontal">
            <div class="form-group">
                <label class="col-md-2 control-label">Field Checked</label>
                <div class="col-md-6">
                    <input
                        id="fieldChecked" type="checkbox" name="fieldChecked" v-model="investigationFieldCheckedDto.fieldChecked" :disabled="isLoading"
                        style="width: 25px; height: 25px">
                    <label for="fieldChecked" />
                </div>
            </div>
            <div class="form-group">
                <label class="col-md-2 control-label">Comments</label>
                <div class="col-md-6">
                    <textarea name="fieldCheckedComments" class="form-control" v-model="investigationFieldCheckedDto.fieldCheckedComments" placeholder="Comments" :disabled="isLoading" />
                </div>
            </div>
            <div class="form-group">
                <div class="col-md-1 col-md-offset-2">
                    <button id="saveFieldChecked" class="btn btn-primary btn-block" v-on:click="saveFieldChecked" :disabled="isLoading">Save</button>
                </div>
            </div>
        </form>
    </div>
</template>

<style>
</style>

<script>
import loggingService from '@/services/util/loggingService'
import investigationService from '../services/investigationService'

export default {
    components: {},
    name: 'investigationCheckedBox',
    data: function () {
        return {
            isDebug: false,
            isLoading: true,
            investigationFieldCheckedDto: {
                investigationId: null,
                fieldChecked: false,
                fieldCheckedComments: ''
            }
        }
    },
    props: {
        investigationId: { default: null }
    },
    watch: {
        investigationId: function () {
            this.investigationFieldCheckedDto.investigationId = this.investigationId
            this.loadData()
        }
    },
    created () {
        loggingService.log(this.isDebug, 'investigationCheckedBox', 'created')
    },
    mounted () {
        loggingService.log(this.isDebug, 'investigationCheckedBox', 'mounted')
        this.loadData()
        this.isLoading = false
    },
    methods: {
        loadData () {
            if (this.investigationFieldCheckedDto.investigationId) {
                loggingService.log(this.isDebug, 'investigationCheckedBox', 'loading data, investigationId: ' + this.investigationId)
                var handle = this
                investigationService.getFieldChecked(this.$http, this.investigationId).then(function (response) {
                    if (response.data) {
                        handle.investigationFieldCheckedDto = response.data
                    }
                })
            }
        },
        saveFieldChecked () {
            if (this.investigationFieldCheckedDto.investigationId) {
                loggingService.log(this.isDebug, 'investigationCheckedBox', 'save')
                this.isLoading = true
                investigationService.saveFieldChecked(this.$http, this.investigationFieldCheckedDto).then(response => {
                    this.loadData()
                    this.isLoading = false
                })
            }
        }
    },
    destroyed () {
        loggingService.log(this.isDebug, 'investigationCheckedBox', 'destroyed')
    }
}

</script>



// WEBPACK FOOTER //
// InvestigationCheckedBox.vue?691448eb